import { util as sdkUtil } from '../util/sdkLoader';
import { denormalisedResponseEntities, ensureOwnListing } from '../util/data';
import * as log from '../util/log';
import { LISTING_STATE_DRAFT } from '../util/types';
import { storableError } from '../util/errors';
import { isUserAuthorized } from '../util/userHelpers';
import { getAllTransitionsForEveryProcess, getTransitionsNeedingProviderAttention } from '../transactions/transaction';

import { authInfo } from './auth.duck';
import { stripeAccountCreateSuccess } from './stripeConnectAccount.duck';
import { fetchNotifications, fetchAcceptedConsultantsExist } from './linkedContacts.duck';
import { manualFieldOptions, manualTransactions, fetchPersonaRecords, iParleySubscriptions, messagePacks, jobRFPSlots, integrityCheckCredits, skillFitCheckCredits, getProfileAccessRequests, sendVendorInvite, getIntegrityCompletionNotifications, markIntegrityCompletionNotificationSeen, getCompanyCredentialDetails } from '../util/api';
import { withCompanyCredentialDetails } from '../util/companyCredentialDetails';
import { withOwnPrivateData } from '../util/withOwnPrivateData';

import socket from '../util/socket';
import { userTypeOf } from '../util/userType';
import { teamRoleOf } from '../util/teamRole';

// ================ Action types ================ //

export const CURRENT_USER_SHOW_REQUEST = 'app/user/CURRENT_USER_SHOW_REQUEST';
export const CURRENT_USER_SHOW_SUCCESS = 'app/user/CURRENT_USER_SHOW_SUCCESS';
export const CURRENT_USER_SHOW_ERROR = 'app/user/CURRENT_USER_SHOW_ERROR';

export const CLEAR_CURRENT_USER = 'app/user/CLEAR_CURRENT_USER';

export const FETCH_CURRENT_USER_HAS_LISTINGS_REQUEST =
  'app/user/FETCH_CURRENT_USER_HAS_LISTINGS_REQUEST';
export const FETCH_CURRENT_USER_HAS_LISTINGS_SUCCESS =
  'app/user/FETCH_CURRENT_USER_HAS_LISTINGS_SUCCESS';
export const FETCH_CURRENT_USER_HAS_LISTINGS_ERROR =
  'app/user/FETCH_CURRENT_USER_HAS_LISTINGS_ERROR';

export const FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST =
  'app/user/FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST';
export const FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS =
  'app/user/FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS';
export const FETCH_CURRENT_USER_NOTIFICATIONS_ERROR =
  'app/user/FETCH_CURRENT_USER_NOTIFICATIONS_ERROR';

export const FETCH_CURRENT_USER_HAS_ORDERS_REQUEST =
  'app/user/FETCH_CURRENT_USER_HAS_ORDERS_REQUEST';
export const FETCH_CURRENT_USER_HAS_ORDERS_SUCCESS =
  'app/user/FETCH_CURRENT_USER_HAS_ORDERS_SUCCESS';
export const FETCH_CURRENT_USER_HAS_ORDERS_ERROR = 'app/user/FETCH_CURRENT_USER_HAS_ORDERS_ERROR';

export const LOAD_FIELD_OPTIONS_REQUEST = 'app/user/LOAD_FIELD_OPTIONS_REQUEST';
export const LOAD_FIELD_OPTIONS_SUCCESS = 'app/user/LOAD_FIELD_OPTIONS_SUCCESS';
export const LOAD_FIELD_OPTIONS_ERROR = 'app/user/LOAD_FIELD_OPTIONS_ERROR';

export const SEND_VERIFICATION_EMAIL_REQUEST = 'app/user/SEND_VERIFICATION_EMAIL_REQUEST';
export const SEND_VERIFICATION_EMAIL_SUCCESS = 'app/user/SEND_VERIFICATION_EMAIL_SUCCESS';
export const SEND_VERIFICATION_EMAIL_ERROR = 'app/user/SEND_VERIFICATION_EMAIL_ERROR';

export const SET_PROFILE_LISTING_ADMIN_ID = 'app/user/SET_PROFILE_LISTING_ADMIN_ID';
export const SET_PROFILE_LISTING = 'app/user/SET_PROFILE_LISTING';



export const FETCH_PERSONA_RECORDS_REQUEST = 'app/user/FETCH_PERSONA_RECORDS_REQUEST';
export const FETCH_PERSONA_RECORDS_SUCCESS = 'app/user/FETCH_PERSONA_RECORDS_SUCCESS';
export const FETCH_PERSONA_RECORDS_ERROR = 'app/user/FETCH_PERSONA_RECORDS_ERROR';

export const FETCH_SUBSCRIPTION_REQUEST = 'app/user/FETCH_SUBSCRIPTION_REQUEST';
export const FETCH_SUBSCRIPTION_SUCCESS = 'app/user/FETCH_SUBSCRIPTION_SUCCESS';
export const FETCH_SUBSCRIPTION_ERROR = 'app/user/FETCH_SUBSCRIPTION_ERROR';

export const SET_MESSAGE_PACKS_OF_USER_REQUEST = 'app/user/SET_MESSAGE_PACKS_OF_USER_REQUEST';
export const SET_MESSAGE_PACKS_OF_USER_SUCCESS = 'app/user/SET_MESSAGE_PACKS_OF_USER_SUCCESS';
export const SET_MESSAGE_PACKS_OF_USER_ERROR = 'app/user/SET_MESSAGE_PACKS_OF_USER_ERROR';

export const FETCH_SMS_BALANCE_REQUEST = 'app/user/FETCH_SMS_BALANCE_REQUEST';
export const FETCH_SMS_BALANCE_SUCCESS = 'app/user/FETCH_SMS_BALANCE_SUCCESS';
export const FETCH_SMS_BALANCE_ERROR = 'app/user/FETCH_SMS_BALANCE_ERROR';

export const GET_ALL_APPLY_TRANSACTIONS_REQUEST = 'app/user/GET_ALL_APPLY_TRANSACTIONS_REQUEST';
export const GET_ALL_APPLY_TRANSACTIONS_SUCCESS = 'app/user/GET_ALL_APPLY_TRANSACTIONS_SUCCESS';
export const GET_ALL_APPLY_TRANSACTIONS_ERROR = 'app/user/GET_ALL_APPLY_TRANSACTIONS_ERROR';

export const SET_JOB_RFP_SLOTS_OF_USER_REQUEST = 'app/user/SET_JOB_RFP_SLOTS_OF_USER_REQUEST';
export const SET_JOB_RFP_SLOTS_OF_USER_SUCCESS = 'app/user/SET_JOB_RFP_SLOTS_OF_USER_SUCCESS';
export const SET_JOB_RFP_SLOTS_OF_USER_ERROR = 'app/user/SET_JOB_RFP_SLOTS_OF_USER_ERROR';

export const SET_INTEGRITY_CHECK_CREDITS_REQUEST = 'app/user/SET_INTEGRITY_CHECK_CREDITS_REQUEST';
export const SET_INTEGRITY_CHECK_CREDITS_SUCCESS = 'app/user/SET_INTEGRITY_CHECK_CREDITS_SUCCESS';
export const SET_INTEGRITY_CHECK_CREDITS_ERROR = 'app/user/SET_INTEGRITY_CHECK_CREDITS_ERROR';

export const SET_SKILLFIT_CHECK_CREDITS_REQUEST = 'app/user/SET_SKILLFIT_CHECK_CREDITS_REQUEST';
export const SET_SKILLFIT_CHECK_CREDITS_SUCCESS = 'app/user/SET_SKILLFIT_CHECK_CREDITS_SUCCESS';
export const SET_SKILLFIT_CHECK_CREDITS_ERROR = 'app/user/SET_SKILLFIT_CHECK_CREDITS_ERROR';
export const SET_SKILLFIT_CHECK_CREDIT_BALANCE_REQUEST = 'app/user/SET_SKILLFIT_CHECK_CREDIT_BALANCE_REQUEST';
export const SET_SKILLFIT_CHECK_CREDIT_BALANCE_SUCCESS = 'app/user/SET_SKILLFIT_CHECK_CREDIT_BALANCE_SUCCESS';
export const SET_SKILLFIT_CHECK_CREDIT_BALANCE_ERROR = 'app/user/SET_SKILLFIT_CHECK_CREDIT_BALANCE_ERROR';

export const FETCH_PROFILE_ACCESS_REQUESTS_REQUEST = 'app/user/FETCH_PROFILE_ACCESS_REQUESTS_REQUEST';
export const FETCH_PROFILE_ACCESS_REQUESTS_SUCCESS = 'app/user/FETCH_PROFILE_ACCESS_REQUESTS_SUCCESS';
export const FETCH_PROFILE_ACCESS_REQUESTS_ERROR = 'app/user/FETCH_PROFILE_ACCESS_REQUESTS_ERROR';

export const FETCH_INTEGRITY_COMPLETION_NOTIFICATIONS_REQUEST = 'app/user/FETCH_INTEGRITY_COMPLETION_NOTIFICATIONS_REQUEST';
export const FETCH_INTEGRITY_COMPLETION_NOTIFICATIONS_SUCCESS = 'app/user/FETCH_INTEGRITY_COMPLETION_NOTIFICATIONS_SUCCESS';
export const FETCH_INTEGRITY_COMPLETION_NOTIFICATIONS_ERROR = 'app/user/FETCH_INTEGRITY_COMPLETION_NOTIFICATIONS_ERROR';
export const MARK_INTEGRITY_COMPLETION_NOTIFICATION_SEEN = 'app/user/MARK_INTEGRITY_COMPLETION_NOTIFICATION_SEEN';

export const SET_ALL_LISTINGS_OF_USER = 'app/user/SET_ALL_LISTINGS_OF_USER';
export const SET_CURRENT_USER_PERSONA_RECORDS = 'app/user/SET_CURRENT_USER_PERSONA_RECORDS';

// ================ Reducer ================ //

const mergeCurrentUser = (oldCurrentUser, newCurrentUser) => {
  const { id: oId, type: oType, attributes: oAttr, ...oldRelationships } = oldCurrentUser || {};
  const { id, type, attributes, ...relationships } = newCurrentUser || {};

  // Passing null will remove currentUser entity.
  // Only relationships are merged.
  // TODO figure out if sparse fields handling needs a better handling.
  return newCurrentUser === null
    ? null
    : oldCurrentUser === null
    ? newCurrentUser
    : { id, type, attributes, ...oldRelationships, ...relationships };
};

const initialState = {
  currentUser: null,
  currentUserShowTimestamp: 0,
  currentUserShowError: null,
  currentUserHasListings: false,
  currentUserHasListingsError: null,
  currentUserNotificationCount: 0,
  currentUserNotificationCountError: null,
  currentUserHasOrders: null, // This is not fetched unless unverified emails exist
  currentUserHasOrdersError: null,
  sendVerificationEmailInProgress: false,
  sendVerificationEmailError: null,
  manualFieldOptions: [],
  profileListing: null,
  // Whether profileListing carries the company's own credential details; a profile save sends
  // them only when it does.
  profileListingCredentialsLoaded: false,
  profileListingAdminId: null,
  personaRecordsInProgress: false,
  personaRecordsError: null,
  personaRecords: [],
  subscriptionInProgress: false,
  subscriptionSuccess: false,
  subscriptionError: false,
  subscriptionsOfUser: null,
  messagePacksOfUser: {},
  messagePacksOfUserSuccess: false,
  messagePacksOfUserError: null,
  // The SMS credit the server reports for the user's organisation:
  // { unlimited, freeAllowance, freeLeft, freeNextAt, packLeft }. Null until read, and after a failed read.
  smsBalance: null,
  smsBalanceInProgress: false,
  smsBalanceError: null,
  allApplyTransactions: [],
  allApplyTransactionsError: null,
  allApplyTransactionsInProgress: false,
  allListingsOfUser: [],
  allJobRFPSlotsOfUser: [],
  setAllJobRFPSlotsOfUserError: null,
  allIntegrityCheckCredits: [],
  integrityCheckCreditsError: null,
  allSkillFitCheckCredits: [],
  skillFitCheckCreditsError: null,
  skillFitCheckCreditBalance: null,
  profileAccessRequests: [],
  profileAccessRequestsError: null,
  profileAccessRequestsInProgress: false,
  integrityCompletionNotifications: [],
  integrityCompletionNotificationsError: null,
  integrityCompletionNotificationsInProgress: false,
  currentUserPersonaRecords: [],
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case CURRENT_USER_SHOW_REQUEST:
      return { ...state, currentUserShowError: null };
    case CURRENT_USER_SHOW_SUCCESS:
      return {
        ...state,
        currentUser: mergeCurrentUser(state.currentUser, payload),
        currentUserShowTimestamp: payload ? new Date().getTime() : 0,
      };
    case CURRENT_USER_SHOW_ERROR:
      return { ...state, currentUserShowError: payload };

    case CLEAR_CURRENT_USER:
      return {
        ...state,
        currentUser: null,
        currentUserShowError: null,
        currentUserHasListings: false,
        currentUserHasListingsError: null,
        currentUserNotificationCount: 0,
        currentUserNotificationCountError: null,
      };

    case FETCH_CURRENT_USER_HAS_LISTINGS_REQUEST:
      return { ...state, currentUserHasListingsError: null };
    case FETCH_CURRENT_USER_HAS_LISTINGS_SUCCESS:
      return { ...state, currentUserHasListings: payload.hasListings };
    case FETCH_CURRENT_USER_HAS_LISTINGS_ERROR:
      return { ...state, currentUserHasListingsError: payload };

    case FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST:
      return { ...state, currentUserNotificationCountError: null };
    case FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS:
      return { ...state, currentUserNotificationCount: payload.transactions.length };
    case FETCH_CURRENT_USER_NOTIFICATIONS_ERROR:
      return { ...state, currentUserNotificationCountError: payload };

    case FETCH_CURRENT_USER_HAS_ORDERS_REQUEST:
      return { ...state, currentUserHasOrdersError: null };
    case FETCH_CURRENT_USER_HAS_ORDERS_SUCCESS:
      return { ...state, currentUserHasOrders: payload.hasOrders };
    case FETCH_CURRENT_USER_HAS_ORDERS_ERROR:
      return { ...state, currentUserHasOrdersError: payload };

    case LOAD_FIELD_OPTIONS_REQUEST:
      return { ...state,  };
    case LOAD_FIELD_OPTIONS_SUCCESS:
      return { ...state, manualFieldOptions: payload.fieldOptions };
    case LOAD_FIELD_OPTIONS_ERROR:
      return { ...state, };

    case SEND_VERIFICATION_EMAIL_REQUEST:
      return {
        ...state,
        sendVerificationEmailInProgress: true,
        sendVerificationEmailError: null,
      };
    case SEND_VERIFICATION_EMAIL_SUCCESS:
      return {
        ...state,
        sendVerificationEmailInProgress: false,
      };
    case SEND_VERIFICATION_EMAIL_ERROR:
      return {
        ...state,
        sendVerificationEmailInProgress: false,
        sendVerificationEmailError: payload,
      };

    case SET_PROFILE_LISTING_ADMIN_ID:
      return {
        ...state,
        profileListingAdminId: payload,
      };
    case SET_PROFILE_LISTING:
      return {
        ...state,
        profileListing: payload.listing,
        profileListingCredentialsLoaded: payload.credentialsLoaded === true,
      };

    case FETCH_PERSONA_RECORDS_REQUEST:
      return {
        ...state,
        personaRecordsInProgress: true,
        personaRecordsError: null,
      };
    case FETCH_PERSONA_RECORDS_SUCCESS:
      return {
        ...state,
        personaRecordsInProgress: false,
        personaRecords: payload || [],
      };
    case FETCH_PERSONA_RECORDS_ERROR:
      return {
        ...state,
        personaRecordsInProgress: false,
        personaRecordsError: payload,
      };

    case FETCH_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        subscriptionInProgress: true,
        subscriptionSuccess: false,
        subscriptionError: false,
      };
    case FETCH_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscriptionInProgress: false,
        subscriptionSuccess: true,
        subscriptionError: false,
        subscriptionsOfUser: payload,
      };
    case FETCH_SUBSCRIPTION_ERROR:
      return {
        ...state,
        subscriptionInProgress: false,
        subscriptionSuccess: false,
        subscriptionError: true,
      };

    case SET_MESSAGE_PACKS_OF_USER_REQUEST:
      return {
        ...state,
        messagePacksOfUserSuccess: false,
        messagePacksOfUserError: null,
      };
    case SET_MESSAGE_PACKS_OF_USER_SUCCESS:
      return {
        ...state,
        messagePacksOfUserSuccess: true,
        messagePacksOfUserError: null,
        messagePacksOfUser: payload,
      };
    case SET_MESSAGE_PACKS_OF_USER_ERROR:
      return {
        ...state,
        messagePacksOfUserSuccess: false,
        messagePacksOfUserError: payload,
      };

    case FETCH_SMS_BALANCE_REQUEST:
      return { ...state, smsBalanceInProgress: true, smsBalanceError: null };
    case FETCH_SMS_BALANCE_SUCCESS:
      return { ...state, smsBalanceInProgress: false, smsBalanceError: null, smsBalance: payload };
    case FETCH_SMS_BALANCE_ERROR:
      return { ...state, smsBalanceInProgress: false, smsBalanceError: payload, smsBalance: null };

    case GET_ALL_APPLY_TRANSACTIONS_REQUEST:
      return {
        ...state,
        allApplyTransactionsInProgress: true,
        allApplyTransactionsError: null,
      };
    case GET_ALL_APPLY_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        allApplyTransactionsInProgress: false,
        allApplyTransactions: payload,
      };
    case GET_ALL_APPLY_TRANSACTIONS_ERROR:
      return {
        ...state,
        allApplyTransactionsInProgress: false,
        allApplyTransactionsError: payload,
      }

    case SET_JOB_RFP_SLOTS_OF_USER_REQUEST:
      return { ...state, allJobRFPSlotsOfUser: [], setAllJobRFPSlotsOfUserError: null };
    case SET_JOB_RFP_SLOTS_OF_USER_SUCCESS:
      return {
        ...state,
        allJobRFPSlotsOfUser: payload,
        setAllJobRFPSlotsOfUserError: null,
      };
    case SET_JOB_RFP_SLOTS_OF_USER_ERROR:
      return {
        ...state,
        allJobRFPSlotsOfUser: [],
        setAllJobRFPSlotsOfUserError: payload
      };

    case SET_INTEGRITY_CHECK_CREDITS_REQUEST:
      return { ...state, allIntegrityCheckCredits: [], integrityCheckCreditsError: null };
    case SET_INTEGRITY_CHECK_CREDITS_SUCCESS:
      return {
        ...state,
        allIntegrityCheckCredits: payload,
        integrityCheckCreditsError: null,
      };
    case SET_INTEGRITY_CHECK_CREDITS_ERROR:
      return {
        ...state,
        allIntegrityCheckCredits: [],
        integrityCheckCreditsError: payload,
      };

    case SET_SKILLFIT_CHECK_CREDITS_REQUEST:
      return { ...state, allSkillFitCheckCredits: [], skillFitCheckCreditsError: null };
    case SET_SKILLFIT_CHECK_CREDITS_SUCCESS:
      return {
        ...state,
        allSkillFitCheckCredits: payload,
        skillFitCheckCreditsError: null,
      };
    case SET_SKILLFIT_CHECK_CREDITS_ERROR:
      return {
        ...state,
        allSkillFitCheckCredits: [],
        skillFitCheckCreditsError: payload,
      };

    // The balance is an optional refinement of the lot list: while it is null the page sums the
    // lots itself. A failed read therefore only clears it and deliberately records no error, so a
    // server that does not answer this action yet never shows the customer a failure.
    case SET_SKILLFIT_CHECK_CREDIT_BALANCE_REQUEST:
    case SET_SKILLFIT_CHECK_CREDIT_BALANCE_ERROR:
      return { ...state, skillFitCheckCreditBalance: null };
    case SET_SKILLFIT_CHECK_CREDIT_BALANCE_SUCCESS:
      return { ...state, skillFitCheckCreditBalance: payload };

    case SET_ALL_LISTINGS_OF_USER:
      return {
        ...state,
        allListingsOfUser: payload,
      };

    case FETCH_PROFILE_ACCESS_REQUESTS_REQUEST:
      return {
        ...state,
        profileAccessRequestsInProgress: true,
        profileAccessRequestsError: null,
      };
    case FETCH_PROFILE_ACCESS_REQUESTS_SUCCESS:
      return {
        ...state,
        profileAccessRequestsInProgress: false,
        profileAccessRequests: payload,
      };
    case FETCH_PROFILE_ACCESS_REQUESTS_ERROR:
      return {
        ...state,
        profileAccessRequestsInProgress: false,
        profileAccessRequestsError: payload,
      };

    case FETCH_INTEGRITY_COMPLETION_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        integrityCompletionNotificationsInProgress: true,
        integrityCompletionNotificationsError: null,
      };
    case FETCH_INTEGRITY_COMPLETION_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        integrityCompletionNotificationsInProgress: false,
        integrityCompletionNotifications: payload,
      };
    case FETCH_INTEGRITY_COMPLETION_NOTIFICATIONS_ERROR:
      return {
        ...state,
        integrityCompletionNotificationsInProgress: false,
        integrityCompletionNotificationsError: payload,
      };

    case MARK_INTEGRITY_COMPLETION_NOTIFICATION_SEEN:
      return {
        ...state,
        integrityCompletionNotifications: (state.integrityCompletionNotifications || []).filter(
          notification => notification.notificationId !== payload
        ),
      };

    case SET_CURRENT_USER_PERSONA_RECORDS:
      return {
        ...state,
        currentUserPersonaRecords: payload,
      };

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const hasCurrentUserErrors = state => {
  const { user } = state;
  return (
    user.currentUserShowError ||
    user.currentUserHasListingsError ||
    user.currentUserNotificationCountError ||
    user.currentUserHasOrdersError
  );
};

export const verificationSendingInProgress = state => {
  return state.user.sendVerificationEmailInProgress;
};

// ================ Action creators ================ //

export const currentUserShowRequest = () => ({ type: CURRENT_USER_SHOW_REQUEST });

export const currentUserShowSuccess = user => ({
  type: CURRENT_USER_SHOW_SUCCESS,
  payload: user,
});

export const currentUserShowError = e => ({
  type: CURRENT_USER_SHOW_ERROR,
  payload: e,
  error: true,
});

export const clearCurrentUser = () => ({ type: CLEAR_CURRENT_USER });

const fetchCurrentUserHasListingsRequest = () => ({
  type: FETCH_CURRENT_USER_HAS_LISTINGS_REQUEST,
});

export const fetchCurrentUserHasListingsSuccess = hasListings => ({
  type: FETCH_CURRENT_USER_HAS_LISTINGS_SUCCESS,
  payload: { hasListings },
});

const fetchCurrentUserHasListingsError = e => ({
  type: FETCH_CURRENT_USER_HAS_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export const fetchCurrentUserNotificationsRequest = () => ({
  type: FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST,
});

export const fetchCurrentUserNotificationsSuccess = transactions => ({
  type: FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS,
  payload: { transactions },
});

const fetchCurrentUserNotificationsError = e => ({
  type: FETCH_CURRENT_USER_NOTIFICATIONS_ERROR,
  error: true,
  payload: e,
});

const fetchCurrentUserHasOrdersRequest = () => ({
  type: FETCH_CURRENT_USER_HAS_ORDERS_REQUEST,
});

export const fetchCurrentUserHasOrdersSuccess = hasOrders => ({
  type: FETCH_CURRENT_USER_HAS_ORDERS_SUCCESS,
  payload: { hasOrders },
});

const fetchCurrentUserHasOrdersError = e => ({
  type: FETCH_CURRENT_USER_HAS_ORDERS_ERROR,
  error: true,
  payload: e,
});

const loadFieldOptionsRequest = () => ({
  type: LOAD_FIELD_OPTIONS_REQUEST,
});

export const loadFieldOptionsSuccess = fieldOptions => ({
  type: LOAD_FIELD_OPTIONS_SUCCESS,
  payload: { fieldOptions },
});

const loadFieldOptionsError = e => ({
  type: LOAD_FIELD_OPTIONS_ERROR,
  error: true,
  payload: e,
});

export const sendVerificationEmailRequest = () => ({
  type: SEND_VERIFICATION_EMAIL_REQUEST,
});

export const sendVerificationEmailSuccess = () => ({
  type: SEND_VERIFICATION_EMAIL_SUCCESS,
});

export const sendVerificationEmailError = e => ({
  type: SEND_VERIFICATION_EMAIL_ERROR,
  error: true,
  payload: e,
});

export const setProfileListingAdminId = (adminId) => ({
  type: SET_PROFILE_LISTING_ADMIN_ID,
  payload: adminId,
});
// A listing set without `credentialsLoaded` is taken not to carry the company's credential details.
export const setProfileListing = (listing, { credentialsLoaded = false } = {}) => ({
  type: SET_PROFILE_LISTING,
  payload: { listing, credentialsLoaded },
});

const fetchPersonaRecordsRequest = () => ({
  type: FETCH_PERSONA_RECORDS_REQUEST,
});

export const fetchPersonaRecordsSuccess = result => ({
  type: FETCH_PERSONA_RECORDS_SUCCESS,
  payload: result,
});

const fetchPersonaRecordsError = e => ({
  type: FETCH_PERSONA_RECORDS_ERROR,
  error: true,
  payload: e,
});

export const fetchSubscriptionRequest = () => ({
  type: FETCH_SUBSCRIPTION_REQUEST,
});
export const fetchSubscriptionSuccess = (response) => ({
  type: FETCH_SUBSCRIPTION_SUCCESS,
  payload: response,
});
export const fetchSubscriptionError = () => ({
  type: FETCH_SUBSCRIPTION_ERROR,
});

export const setMessagePacksOfUserRequest = () => ({
  type: SET_MESSAGE_PACKS_OF_USER_REQUEST,
});
export const setMessagePacksOfUserSuccess = (response) => ({
  type: SET_MESSAGE_PACKS_OF_USER_SUCCESS,
  payload: response,
});
export const setMessagePacksOfUserError = () => ({
  type: SET_MESSAGE_PACKS_OF_USER_ERROR,
});

export const fetchSmsBalanceRequest = () => ({ type: FETCH_SMS_BALANCE_REQUEST });
export const fetchSmsBalanceSuccess = balance => ({ type: FETCH_SMS_BALANCE_SUCCESS, payload: balance });
export const fetchSmsBalanceError = e => ({ type: FETCH_SMS_BALANCE_ERROR, payload: e });

export const setJobRFPSlotsOfUserRequest = () => ({
  type: SET_JOB_RFP_SLOTS_OF_USER_REQUEST,
});
export const setJobRFPSlotsOfUserSuccess = (response) => ({
  type: SET_JOB_RFP_SLOTS_OF_USER_SUCCESS,
  payload: response,
});
export const setJobRFPSlotsOfUserError = (e) => ({
  type: SET_JOB_RFP_SLOTS_OF_USER_ERROR,
  payload: e,
});

export const setIntegrityCheckCreditsRequest = () => ({
  type: SET_INTEGRITY_CHECK_CREDITS_REQUEST,
});
export const setIntegrityCheckCreditsSuccess = (response) => ({
  type: SET_INTEGRITY_CHECK_CREDITS_SUCCESS,
  payload: response,
});
export const setIntegrityCheckCreditsError = (e) => ({
  type: SET_INTEGRITY_CHECK_CREDITS_ERROR,
  payload: e,
});

export const setSkillFitCheckCreditsRequest = () => ({
  type: SET_SKILLFIT_CHECK_CREDITS_REQUEST,
});
export const setSkillFitCheckCreditsSuccess = (response) => ({
  type: SET_SKILLFIT_CHECK_CREDITS_SUCCESS,
  payload: response,
});
export const setSkillFitCheckCreditsError = (e) => ({
  type: SET_SKILLFIT_CHECK_CREDITS_ERROR,
  payload: e,
});

export const setSkillFitCheckCreditBalanceRequest = () => ({
  type: SET_SKILLFIT_CHECK_CREDIT_BALANCE_REQUEST,
});
export const setSkillFitCheckCreditBalanceSuccess = (response) => ({
  type: SET_SKILLFIT_CHECK_CREDIT_BALANCE_SUCCESS,
  payload: response,
});
export const setSkillFitCheckCreditBalanceError = () => ({
  type: SET_SKILLFIT_CHECK_CREDIT_BALANCE_ERROR,
});

export const getAllApplyTransactionsRequest = () => ({
  type: GET_ALL_APPLY_TRANSACTIONS_REQUEST,
});
export const getAllApplyTransactionsSuccess = (response) => ({
  type: GET_ALL_APPLY_TRANSACTIONS_SUCCESS,
  payload: response,
});
export const getAllApplyTransactionsError = () => ({
  type: GET_ALL_APPLY_TRANSACTIONS_ERROR,
});

export const fetchProfileAccessRequestsRequest = () => ({
  type: FETCH_PROFILE_ACCESS_REQUESTS_REQUEST,
});
export const fetchProfileAccessRequestsSuccess = (requests) => ({
  type: FETCH_PROFILE_ACCESS_REQUESTS_SUCCESS,
  payload: requests,
});
export const fetchProfileAccessRequestsError = (error) => ({
  type: FETCH_PROFILE_ACCESS_REQUESTS_ERROR,
  payload: error,
  error: true,
});

export const fetchIntegrityCompletionNotificationsRequest = () => ({
  type: FETCH_INTEGRITY_COMPLETION_NOTIFICATIONS_REQUEST,
});

export const fetchIntegrityCompletionNotificationsSuccess = notifications => ({
  type: FETCH_INTEGRITY_COMPLETION_NOTIFICATIONS_SUCCESS,
  payload: notifications,
});

export const fetchIntegrityCompletionNotificationsError = error => ({
  type: FETCH_INTEGRITY_COMPLETION_NOTIFICATIONS_ERROR,
  payload: error,
  error: true,
});

export const markIntegrityCompletionNotificationSeenSuccess = notificationId => ({
  type: MARK_INTEGRITY_COMPLETION_NOTIFICATION_SEEN,
  payload: notificationId,
});

export const setAllListingsofUser = (response) => ({
  type: SET_ALL_LISTINGS_OF_USER,
  payload: response,
});

export const setCurrentUserPersonaRecords = (payload) => ({
  type: SET_CURRENT_USER_PERSONA_RECORDS,
  payload: payload,
});

// ================ Thunks ================ //

function getLatestEndedSubscription(subscriptionOfUser) {
  if (!Array.isArray(subscriptionOfUser) || subscriptionOfUser.length === 0) return null;

  const endedSubscriptions = subscriptionOfUser.filter(sub => {
    // Check both subscriptionData.status and top-level status
    const status = sub?.subscriptionData?.status || sub?.status;
    return ['canceled', 'unpaid', 'incomplete_expired', 'incomplete', 'past_due'].includes(status);
  });

  if (endedSubscriptions.length === 0) return null;

  // Sort a cloned array (not in-place)
  const sorted = [...endedSubscriptions].sort((a, b) => {
    const aDate = new Date(a.cancelledAt || a.expiry || 0);
    const bDate = new Date(b.cancelledAt || b.expiry || 0);

    return bDate - aDate;
  });

  return [sorted[0]];
}

// A company's profile listing with the details only its members may see laid over it, and whether
// they were. If they cannot be loaded, the listing is returned as it is.
export const loadCompanyCredentialDetails = async (listing, profileListingId) => {
  let details = null;
  try {
    details = listing ? await getCompanyCredentialDetails(profileListingId) : null;
  } catch (e) {
    details = null;
  }
  return { listing: withCompanyCredentialDetails(listing, details), credentialsLoaded: !!details };
};

const setCompanyProfileListing = async (listing, profileListingId, dispatch) => {
  const loaded = await loadCompanyCredentialDetails(listing, profileListingId);
  dispatch(setProfileListing(loaded.listing, { credentialsLoaded: loaded.credentialsLoaded }));
};

const getMainAccountId = async (user, sdk, dispatch) => {
  if (!user) return null;

  const profileListingId = user.attributes?.profile?.publicData?.profileListingId;

  if (!profileListingId) {
    return user.id?.uuid;
  }

  const userType = userTypeOf(user);
  const role = teamRoleOf(user);

  if (userType === 'agency' || userType === 'customer') {
    if ((role === 'Admin' && user?.attributes?.profile?.publicData?.firstListingId !== undefined) || role === 'undefined') {
      let listingResponse = null;

      try {
        listingResponse = await sdk.listings.show({ id: profileListingId });
      } catch(err) {
        return;
      }
      const listing = listingResponse?.data?.data;

      await setCompanyProfileListing(listing, profileListingId, dispatch);

      return user.id?.uuid;
    } else {
      let listingResponse = null;

      try {
        listingResponse = await sdk.listings.show({ id: profileListingId });
      } catch(err) {
        return;
      }

      const listing = listingResponse?.data?.data;

      await setCompanyProfileListing(listing, profileListingId, dispatch);

      return listing?.attributes?.publicData?.adminId;
    }
  }

  let listingResponse = null;

  try {
    listingResponse = await sdk.listings.show({ id: profileListingId });
  } catch(err) {
    return;
  }

  const listing = listingResponse?.data?.data;

  // A candidate's wallet records are in their listing's private data, which the public read above
  // does not return; their own screens read them from here.
  dispatch(setProfileListing(await withOwnPrivateData(listing, profileListingId)));

  return user.id?.uuid;
};

/**
 * The user id that owns the signed-in user's organisation links (the organisation's admin, or the
 * user themself), stored once learned. Only the notifications load stores it otherwise, and a page
 * can load before that has finished.
 *
 * @returns the id, or null when it cannot be learned
 */
export const ensureProfileListingAdminId = () => async (dispatch, getState, sdk) => {
  const { currentUser, profileListingAdminId } = getState().user;
  if (profileListingAdminId) {
    return profileListingAdminId;
  }
  const adminId = await getMainAccountId(currentUser, sdk, dispatch);
  if (!adminId) {
    return null;
  }
  dispatch(setProfileListingAdminId(adminId));
  return adminId;
};

export const getUserProfileListing = () => async (dispatch, getState, sdk) => {
  const { currentUser } = getState().user;
  
  try {
    await getMainAccountId(currentUser, sdk, dispatch);
    return true;
  } catch (error) {
    return false;
  }
};

export const fetchCurrentUserHasListings = () => (dispatch, getState, sdk) => {
  dispatch(fetchCurrentUserHasListingsRequest());
  const { currentUser } = getState().user;

  if (!currentUser) {
    dispatch(fetchCurrentUserHasListingsSuccess(false));
    return Promise.resolve(null);
  }

  const params = {
    // Since we are only interested in if the user has published
    // listings, we only need at most one result.
    states: 'published',
    page: 1,
    perPage: 1,
  };

  return sdk.ownListings
    .query(params)
    .then(response => {
      const hasListings = response.data.data && response.data.data.length > 0;

      const hasPublishedListings =
        hasListings &&
        ensureOwnListing(response.data.data[0]).attributes.state !== LISTING_STATE_DRAFT;
      dispatch(fetchCurrentUserHasListingsSuccess(!!hasPublishedListings));
    })
    .catch(e => dispatch(fetchCurrentUserHasListingsError(storableError(e))));
};

export const fetchCurrentUserHasOrders = () => (dispatch, getState, sdk) => {
  dispatch(fetchCurrentUserHasOrdersRequest());

  if (!getState().user.currentUser) {
    dispatch(fetchCurrentUserHasOrdersSuccess(false));
    return Promise.resolve(null);
  }

  const params = {
    only: 'order',
    page: 1,
    perPage: 1,
  };

  return sdk.transactions
    .query(params)
    .then(response => {
      const hasOrders = response.data.data && response.data.data.length > 0;
      dispatch(fetchCurrentUserHasOrdersSuccess(!!hasOrders));
    })
    .catch(e => dispatch(fetchCurrentUserHasOrdersError(storableError(e))));
};

export const loadFieldOptions = () => (dispatch, getState, sdk) => {
  dispatch(loadFieldOptionsRequest());
  return manualFieldOptions({ type: 'fetch'})
    .then(response => {
      const fieldOptions = response;
      dispatch(loadFieldOptionsSuccess(fieldOptions));
    })
    .catch(e => dispatch(loadFieldOptionsError(storableError(e))));
};

export const sendVendorInviteDuck = (params) => async (dispatch, getState, sdk) => {
  const state = getState();
  const { currentUser } = state.user;

  const vendors = params?.vendors?.filter(x => !x.emailSent && x.email);
  if (vendors?.length) {
    const currentUserName = currentUser.attributes.profile.displayName;
    const currentUserId = currentUser.id.uuid;
    const customerName = currentUser?.attributes?.profile?.publicData?.customerProfile?.name || currentUser?.attributes?.profile?.displayName;

    // Group vendors by type to make separate API calls
    // const staffingVendors = vendors.filter(v => v.type === 'staffing' || v.vendorType === 'staffing');
    // const implementationVendors = vendors.filter(v => v.type === 'implementation' || v.vendorType === 'implementation');

    // const invitationPromises = [];

    // // Send staffing vendor invitations
    // if (staffingVendors.length > 0) {
    //   invitationPromises.push(
    //     sendVendorInvite({
    //       vendors: staffingVendors,
    //       customerName,
    //       customerId: currentUserId,
    //       vendorType: 'staffing'
    //     })
    //   );
    // }

    // // Send implementation vendor invitations
    // if (implementationVendors.length > 0) {
    //   invitationPromises.push(
    //     sendVendorInvite({
    //       vendors: implementationVendors,
    //       customerName,
    //       customerId: currentUserId,
    //       vendorType: 'implementation'
    //     })
    //   );
    // }

    // return Promise.all(invitationPromises)
    return sendVendorInvite({ vendors, currentUserName, currentUserId, customerName })
      .catch(e => {
        // Error handled silently - vendor invites can fail
      });
  }

  return false;
};

export const fetchUserPersonaRecords = (profileListingId) => (dispatch, getState, sdk) => {
  if (!profileListingId) {
    return Promise.resolve(null);
  }

  dispatch(fetchPersonaRecordsRequest());

  return fetchPersonaRecords({ profileListingId: profileListingId })
    .then(res => {
      if (res.success && res.data) {
        dispatch(fetchPersonaRecordsSuccess(res.data));
        return res.data;
      } else {
        throw new Error('Failed to fetch persona records');
      }
    })
    .catch(e => {
      dispatch(fetchPersonaRecordsError(storableError(e)));
    });
};

export const fetchCurrentUserProfileAccessRequests = () => (dispatch, getState, sdk) => {
  const state = getState();
  const { currentUser } = state.user;
  const currentUserId = currentUser?.id?.uuid;

  if (!currentUserId) {
    return Promise.resolve(null);
  }

  dispatch(fetchProfileAccessRequestsRequest());

  return getProfileAccessRequests({ profileOwnerId: currentUserId })
    .then(res => {
      if (res.success && res.requests) {
        dispatch(fetchProfileAccessRequestsSuccess(res.requests));
        return res.requests;
      } else {
        throw new Error('Failed to fetch profile access requests');
      }
    })
    .catch(e => {
      dispatch(fetchProfileAccessRequestsError(storableError(e)));
    });
};

export const fetchCurrentUserIntegrityCompletionNotifications = () => (dispatch, getState, sdk) => {
  const state = getState();
  const userType = userTypeOf(state?.user?.currentUser);

  if (userType !== 'customer') {
    dispatch(fetchIntegrityCompletionNotificationsSuccess([]));
    return Promise.resolve([]);
  }

  dispatch(fetchIntegrityCompletionNotificationsRequest());

  return getIntegrityCompletionNotifications()
    .then(res => {
      const notifications = Array.isArray(res?.notifications) ? res.notifications : [];
      dispatch(fetchIntegrityCompletionNotificationsSuccess(notifications));
      return notifications;
    })
    .catch(e => {
      dispatch(fetchIntegrityCompletionNotificationsError(storableError(e)));
      return [];
    });
};

export const markIntegrityCompletionNotificationSeenDuck = payload => (dispatch, getState, sdk) => {
  const notificationId = payload?.notificationId;

  if (!notificationId) {
    return Promise.resolve(false);
  }

  return markIntegrityCompletionNotificationSeen(payload)
    .then(res => {
      if (res?.updated) {
        dispatch(markIntegrityCompletionNotificationSeenSuccess(notificationId));
      }
      return !!res?.updated;
    })
    .catch(() => false);
};

// Marks the employer's answer, identified by its date, as seen by the candidate, which hides its
// bell notice. Answers whether it was stored; a failure leaves the notice showing.
export const markEmployerAnswerSeen = answeredAt => (dispatch, getState, sdk) => {
  if (typeof answeredAt !== 'string' || !answeredAt) {
    return Promise.resolve(false);
  }

  return sdk.currentUser
    .updateProfile({ privateData: { currentEmployerAnswerSeenAt: answeredAt } }, { expand: true })
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
      }
      dispatch(currentUserShowSuccess(entities[0]));
      return true;
    })
    .catch(e => {
      log.error(e, 'mark-employer-answer-seen-failed');
      return false;
    });
};

// Notificaiton page size is max (100 items on page)
const NOTIFICATION_PAGE_SIZE = 100;

export const getManualTransactions = async (sdk, dispatch, userId) => {
  
  
  try {
    const txns = await manualTransactions({ userAId: userId, type:'fetch' });
    
    return txns || [];
  } catch (error) {
    
    return null;
  }
};

export const fetchCurrentUserNotifications = () => async (dispatch, getState, sdk) => {
  const transitionsNeedingAttention = getTransitionsNeedingProviderAttention();
  if (transitionsNeedingAttention.length === 0) {
    // Don't update state, if there's no need to draw user's attention after last transitions.
    return;
  }

  const currentUser = getState().user?.currentUser;
  const currentUserId = currentUser?.id?.uuid;
  let profileListingAdminId = null;

  const isAgencyOrCustomer = userTypeOf(currentUser) !== 'candidate';
  const role = teamRoleOf(currentUser);

  let requiresManualMessageFetching = false;

  let apiQueryParams = {
    only: 'sale',
    last_transitions: transitionsNeedingAttention,
    page: 1,
    perPage: NOTIFICATION_PAGE_SIZE,
  };

  requiresManualMessageFetching = true;
    
  const mainUserId = await getMainAccountId(currentUser, sdk, dispatch);
  profileListingAdminId = mainUserId;

  dispatch(setProfileListingAdminId(profileListingAdminId));

  dispatch(fetchCurrentUserNotificationsRequest());

  if(isAgencyOrCustomer) {
    requiresManualMessageFetching = true;

    // const mainUserId = await getMainAccountId(currentUser, sdk, dispatch);
    // profileListingAdminId = mainUserId;

    apiQueryParams = {
      userId: mainUserId,
      lastTransitions: getAllTransitionsForEveryProcess(),
      include: [
        'listing',
        'provider',
        'provider.profileImage',
        'provider.profile',
        'customer',
        'customer.profileImage',
        'customer.profile',
        'booking',
        'messages',
        'messages.sender'
      ],
      'fields.transaction': [
        'processName',
        'lastTransition',
        'lastTransitionedAt',
        'transitions',
        'payinTotal',
        'payoutTotal',
        'lineItems',
        'metadata',
      ],
      'fields.listing': ['title', 'availabilityPlan', 'publicData.listingType'],
      'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'deleted', 'banned'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
      perPage: NOTIFICATION_PAGE_SIZE,
      hasMessages: true,
    };
  } else {
    profileListingAdminId = currentUserId;

    apiQueryParams = {
      userId: profileListingAdminId,
      lastTransitions: getAllTransitionsForEveryProcess(),
      include: [
        'listing',
        'provider',
        'provider.profileImage',
        'provider.profile',
        'customer',
        'customer.profileImage',
        'customer.profile',
        'booking',
        'messages',
        'messages.sender'
      ],
      'fields.transaction': [
        'processName',
        'lastTransition',
        'lastTransitionedAt',
        'transitions',
        'payinTotal',
        'payoutTotal',
        'lineItems',
        'metadata',
      ],
      'fields.listing': ['title', 'availabilityPlan', 'publicData.listingType'],
      'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'deleted', 'banned'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
      perPage: NOTIFICATION_PAGE_SIZE,
      hasMessages: true,
    };
  }

  let allTransactions = [];
  let allTxns = [];

  try {
    const allTransactionsResponse = await getManualTransactions(sdk, dispatch, mainUserId);
    allTransactions = allTransactionsResponse;
    // allTransactions = allTransactionsResponse?.allTransactions;

    allTxns = allTransactions || [];
    // allTxns = allTransactionsResponse?.allTransactions?.[0]?.data ?? [];
  } catch (error) {
    dispatch(fetchCurrentUserNotificationsError(storableError(error)))
  }

  let notificationsCountLocal = 0;

  let notificationsCountLength = [];

  allTxns?.map(txn => {
    if(txn?.metadata?.seenByReceivedUser === false && mainUserId !== txn?.metadata?.sentByUser) {
      notificationsCountLocal += 1;
      notificationsCountLength.push(notificationsCountLocal);
    } 
  });

  dispatch(fetchCurrentUserNotificationsSuccess(notificationsCountLength));

  // sdk.transactions
  //   .query(apiQueryParams)
  //   .then(response => {
  //     const transactions = response.data.data;
  //     dispatch(fetchCurrentUserNotificationsSuccess(transactions));
  //   })
  //   .catch(e => dispatch(fetchCurrentUserNotificationsError(storableError(e))));
};

/**
 * Fetch currentUser API entity.
 *
 * @param {Object} options
 * @param {Object} [options.callParams]           Optional parameters for the currentUser.show().
 * @param {boolean} [options.updateHasListings]   Make extra call for fetchCurrentUserHasListings()?
 * @param {boolean} [options.updateNotifications] Make extra call for fetchCurrentUserNotifications()?
 * @param {boolean} [options.afterLogin]          Fetch is no-op for unauthenticated users except after login() call
 * @param {boolean} [options.enforce]             Enforce the call even if the currentUser entity is freshly fetched.
 */
export const fetchCurrentUser = options => (dispatch, getState, sdk) => {
  const state = getState();
  const { currentUserHasListings, currentUserShowTimestamp } = state.user || {};
  const { isAuthenticated } = state.auth;
  const {
    callParams = null,
    updateHasListings = true,
    updateNotifications = true,
    afterLogin,
    enforce = false, // Automatic emailVerification might be called too fast
  } = options || {};

  // Double fetch might happen when e.g. profile page is making a full page load
  const aSecondAgo = new Date().getTime() - 1000;
  if (!enforce && currentUserShowTimestamp > aSecondAgo) {
    return Promise.resolve({});
  }
  // Set in-progress, no errors
  dispatch(currentUserShowRequest());

  if (!isAuthenticated && !afterLogin) {
    // Make sure current user is null
    dispatch(currentUserShowSuccess(null));
    return Promise.resolve({});
  }

  const parameters = callParams || {
    include: ['effectivePermissionSet', 'profileImage', 'stripeAccount'],
    'fields.image': [
      'variants.square-small',
      'variants.square-small2x',
      'variants.square-xsmall',
      'variants.square-xsmall2x',
    ],
    'imageVariant.square-xsmall': sdkUtil.objectQueryString({
      w: 40,
      h: 40,
      fit: 'crop',
    }),
    'imageVariant.square-xsmall2x': sdkUtil.objectQueryString({
      w: 80,
      h: 80,
      fit: 'crop',
    }),
  };

  return sdk.currentUser
    .show(parameters)
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error('Expected a resource in the sdk.currentUser.show response');
      }
      const currentUser = entities[0];

      // Save stripeAccount to store.stripe.stripeAccount if it exists
      if (currentUser.stripeAccount) {
        dispatch(stripeAccountCreateSuccess(currentUser.stripeAccount));
      }

      // set current user id to the logger
      log.setUserId(currentUser.id.uuid);
      dispatch(currentUserShowSuccess(currentUser));
      // The bell's link notifications, for every signed-in user whether or not they have a profile yet.
      dispatch(fetchNotifications());
      // Whether an agency has anyone to apply with, so Apply can say so before opening a picker.
      if (userTypeOf(currentUser) === 'agency') {
        dispatch(fetchAcceptedConsultantsExist());
      }
      return currentUser;
    })
    .then(async currentUser => {
      // If currentUser is not active (e.g. in 'pending-approval' state),
      // then they don't have listings or transactions that we care about.
      const mainUserId = await getMainAccountId(currentUser, sdk, dispatch);

      if (isUserAuthorized(currentUser)) {
        if (currentUserHasListings === false && updateHasListings !== false) {
          dispatch(fetchCurrentUserHasListings());
        }

        if (updateNotifications !== false) {
          dispatch(fetchCurrentUserNotifications());
        }

        const isCustomer = userTypeOf(currentUser) === 'customer';
        if (isCustomer) {
          let page = 1;
          let totalPages = 1;
          let allListingsOfUser = [];

          do {
            const listingsResponse = await sdk.listings.query({
              authorId: mainUserId,
              page,
              perPage: 100,
            });

            const pageListings = listingsResponse?.data?.data || [];
            allListingsOfUser = allListingsOfUser.concat(pageListings);
            totalPages = listingsResponse?.data?.meta?.totalPages || 1;
            page += 1;
          } while (page <= totalPages);

          dispatch(setAllListingsofUser(allListingsOfUser));
        }

        if (!currentUser.attributes.emailVerified) {
          dispatch(fetchCurrentUserHasOrders());
        }
      }

      const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId || currentUser?.attributes?.profile?.publicData?.firstListingId;

      if (profileListingId) {
        try {
          const currentUserPersonaRecordsResponse = await fetchPersonaRecords({profileListingId});
          dispatch(setCurrentUserPersonaRecords(currentUserPersonaRecordsResponse?.data));
          dispatch(fetchSubscriptionRequest());
          const subscriptionOfUser = await iParleySubscriptions({ actionType: 'fetch', profileListingId });

          await dispatch(getMessagePacksOfUser());

          if (userTypeOf(currentUser) === 'customer') {
            await dispatch(getJobRFPSlotsOfUser());
          }

          // 'trialing' = active free-trial subscription (auto-charges at trial end)
          const activeSubscriptionOfUser = subscriptionOfUser?.filter(sub => sub?.status === 'active' || sub?.status === 'trialing' );
          if (!(activeSubscriptionOfUser?.length > 0)) {
            const dispatchSubsOfUser = await getLatestEndedSubscription(subscriptionOfUser);
            dispatch(fetchSubscriptionSuccess(dispatchSubsOfUser));
          } else {
            dispatch(fetchSubscriptionSuccess(activeSubscriptionOfUser))
          }
        } catch (err) {
          dispatch(fetchSubscriptionError());
        }

        dispatch(fetchCurrentUserProfileAccessRequests());
        dispatch(fetchCurrentUserIntegrityCompletionNotifications());
      }

      dispatch(loadFieldOptions());

      // Make sure auth info is up to date
      dispatch(authInfo());
    })
    .catch(e => {
      // Make sure auth info is up to date
      dispatch(authInfo());
      log.error(e, 'fetch-current-user-failed');
      dispatch(currentUserShowError(storableError(e)));
    });
};

export const sendVerificationEmail = () => (dispatch, getState, sdk) => {
  if (verificationSendingInProgress(getState())) {
    return Promise.reject(new Error('Verification email sending already in progress'));
  }
  dispatch(sendVerificationEmailRequest());
  return sdk.currentUser
    .sendVerificationEmail()
    .then(() => dispatch(sendVerificationEmailSuccess()))
    .catch(e => dispatch(sendVerificationEmailError(storableError(e))));
};

export const getMessagePacksOfUser = () => (dispatch, getState, sdk) => {
  dispatch(setMessagePacksOfUserRequest());
  
  const state = getState();
  const { currentUser } = state.user;

  return messagePacks({ actionType: 'fetch', profileListingId: currentUser?.attributes?.profile?.publicData?.profileListingId })
    .then(response => {
      dispatch(setMessagePacksOfUserSuccess(response));
    })
    .catch(e => {
      dispatch(setMessagePacksOfUserError(storableError(e)))
    });
};

// Reads the SMS credit left for the signed-in user's organisation. The server works it out; the
// pages only show it. A failed read leaves no balance, so nothing is blocked on it and the server
// still decides when an SMS is actually sent.
export const fetchSmsBalance = () => dispatch => {
  dispatch(fetchSmsBalanceRequest());
  return messagePacks({ actionType: 'smsBalance' })
    .then(balance => {
      dispatch(fetchSmsBalanceSuccess(balance));
      return balance;
    })
    .catch(e => {
      dispatch(fetchSmsBalanceError(storableError(e)));
      return null;
    });
};

// True only when a balance has been read and it shows no SMS credit of any kind left.
// While the balance is loading or could not be read this is false.
export const hasNoSmsCredit = smsBalance =>
  !!smsBalance &&
  !smsBalance.unlimited &&
  smsBalance.freeLeft === 0 &&
  smsBalance.packLeft === 0;

export const getJobRFPSlotsOfUser = () => (dispatch, getState, sdk) => {
  dispatch(setJobRFPSlotsOfUserRequest());

  const state = getState();
  const { currentUser } = state.user;

  return jobRFPSlots({ actionType: 'fetch', profileListingId: currentUser?.attributes?.profile?.publicData?.profileListingId })
    .then(response => {
      dispatch(setJobRFPSlotsOfUserSuccess(response));
    })
    .catch(e => {
      dispatch(setJobRFPSlotsOfUserError(storableError(e)))
    });
};

export const getIntegrityCheckCreditsOfUser = () => (dispatch, getState, sdk) => {
  dispatch(setIntegrityCheckCreditsRequest());

  const state = getState();
  const { currentUser } = state.user;

  return integrityCheckCredits({ actionType: 'fetch', profileListingId: currentUser?.attributes?.profile?.publicData?.profileListingId })
    .then(response => {
      dispatch(setIntegrityCheckCreditsSuccess(response));
    })
    .catch(e => {
      dispatch(setIntegrityCheckCreditsError(storableError(e)))
    });
};

export const getSkillFitCheckCreditsOfUser = () => (dispatch, getState, sdk) => {
  dispatch(setSkillFitCheckCreditsRequest());

  const state = getState();
  const { currentUser } = state.user;

  return skillFitCheckCredits({ actionType: 'fetch', profileListingId: currentUser?.attributes?.profile?.publicData?.profileListingId })
    .then(response => {
      dispatch(setSkillFitCheckCreditsSuccess(response));
    })
    .catch(e => {
      dispatch(setSkillFitCheckCreditsError(storableError(e)))
    });
};

export const getSkillFitCheckCreditBalanceOfUser = () => (dispatch, getState, sdk) => {
  dispatch(setSkillFitCheckCreditBalanceRequest());

  const state = getState();
  const { currentUser } = state.user;

  return skillFitCheckCredits({ actionType: 'balance', profileListingId: currentUser?.attributes?.profile?.publicData?.profileListingId })
    .then(response => {
      dispatch(setSkillFitCheckCreditBalanceSuccess(response));
    })
    .catch(() => {
      dispatch(setSkillFitCheckCreditBalanceError());
    });
};

export const getAllApplyTransactions = () => async (dispatch, getState, sdk) => {
  dispatch(getAllApplyTransactionsRequest());
  
  try {
    const currentUser = getState().user?.currentUser;
    const mainUserId = await getMainAccountId(currentUser, sdk, dispatch);

    let txns = [];
    
    if (userTypeOf(currentUser) === 'candidate') {
      txns = await manualTransactions({ userAId: mainUserId, type:'fetch', txType: 'apply' });
    } else if (userTypeOf(currentUser) === 'agency') {
      const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId;
      if (!profileListingId) {
        dispatch(getAllApplyTransactionsSuccess([]));
        return [];
      }
      txns = await manualTransactions({ agencyListingId: profileListingId, appliedByAgency: true, type:'fetch', txType: 'apply' });
    }

    
    
    dispatch(getAllApplyTransactionsSuccess(txns));
    return txns;
  } catch (error) {
    dispatch(getAllApplyTransactionsError());
  }
};
